module.exports = {

	methods: {
		promptError: function(message) {
			var self = this;

			if(typeof message == 'undefined' || !message){
				message = self.$t('errorMessage')
			}

			window.eventHub.$emit('openModal', { 
					modal: 'message', 
					data: { 
						title: self.$t('errorTitle'), 
						message: message ,
						confirmTxt: self.$t('close'),
						confirm: true,
						onConfirm: function(){
							window.eventHub.$emit('closeModal');
						}
					} 
			});
		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/error.js